import React from "react";
import { Box, Typography } from "@mui/material";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";

const ComingSoon = () => {
  return (
    <Box
      sx={{
        minHeight: "80vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "#f5f6fa",
      }}
    >
      <HourglassEmptyIcon sx={{ fontSize: 64, color: "primary.main", mb: 2 }} />
      <Typography variant="h4" sx={{ fontWeight: 600, mb: 1 }}>
        Coming Soon
      </Typography>
      <Typography variant="body1" color="text.secondary">
        This feature is under development. Please check back later!
      </Typography>
    </Box>
  );
};

export default ComingSoon;
